import * as React from 'react';
import { Flex as StyledFlex } from '@chakra-ui/core';
import { FlexProps as Props } from '@chakra-ui/core/dist/Flex';

interface FlexProps extends Props {}

const Flex: React.FC<FlexProps> = (
    React.forwardRef((props: FlexProps, ref: React.ElementRef<any>) => (
        <StyledFlex ref={ref} {...props} />
    ))
);

export { FlexProps };

export default Flex;
